



























































































import Vue from 'vue'
import TalentEmblem from './talent/_TalentEmblem.vue'
import TalentRankContents from './talent/_TalentRankContents.vue'

export default Vue.extend({
  name: 'talent-card',
  components: { TalentEmblem, TalentRankContents },
  props: {
    hideLocked: { type: Boolean },
    item: { type: Object, required: true },
    selectable: { type: Boolean },
    canAdd: { type: Boolean },
    rank: { type: [Number, String], required: false, default: null },
  },
  data: () => ({
    showAll: false,
  }),
  computed: {
    showFull() {
      if (this.hideLocked) return this.showAll
      return true
    },
  },
})
